<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" >
      <div class="location-layout">
        <el-form-item label="培训id" prop="trainingId">
          <el-input v-model="dataForm.trainingId" placeholder="培训id"></el-input>
        </el-form-item>
        <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item label="培训url" prop="trainingUrl">
          <el-input v-model="dataForm.trainingUrl" placeholder="培训url"></el-input>
        </el-form-item>
        <el-form-item label="培训标题" prop="trainingTitle">
          <el-input v-model="dataForm.trainingTitle" placeholder="培训标题"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="btn-position-up">
      <el-button type="primary" @click="dataFormSubmitHandle()">保存</el-button>
      <el-button @click="backPage()">返回</el-button>
    </div>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        userTrainingId: 0,
        trainingId: '',
        userId: '',
        trainingUrl: '',
        trainingTitle: ''
      },
      dataRule: {
        trainingId: [
          { required: true, message: '培训id不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        trainingUrl: [
          { required: true, message: '培训url不能为空', trigger: 'blur' }
        ],
        trainingTitle: [
          { required: true, message: '培训标题不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  activated () {
    this.$nextTick(() => {
      this.$refs['dataForm'].resetFields()
      if (this.$route.query.userTrainingId !== undefined) {
        this.dataForm.userTrainingId = this.$route.query.userTrainingId
        this.getInfo()
      }
    })
  },
  methods: {
    // 获取信息
    getInfo () {
      this.$request.get(`/sys/commusertraining/info/${this.dataForm.userTrainingId}`).then((data) => {
        this.dataForm.trainingId = data.trainingId
        this.dataForm.userId = data.userId
        this.dataForm.trainingUrl = data.trainingUrl
        this.dataForm.trainingTitle = data.trainingTitle
      })
    },
    // 表单提交
    dataFormSubmitHandle () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$request.post(
            `/sys/commusertraining/${!this.dataForm.userTrainingId ? 'save' : 'update'}`,
            {
              'userTrainingId': this.dataForm.userTrainingId || undefined,
              'trainingId': this.dataForm.trainingId,
              'userId': this.dataForm.userId,
              'trainingUrl': this.dataForm.trainingUrl,
              'trainingTitle': this.dataForm.trainingTitle
            }
          ).then((data) => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.$router.go(-1)
              }
            })
          })
        }
      })
    },
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>
